// This file is used by the Angular `development` build configuration.

export const environment = {
  production: false,
  footprintsSchema: 'work',
  environmentName: 'dev',
  appVersion: 'v8.2.4',
  laravelApi: 'https://backend.dev.waiis.eco/api',
  laravelBackoffice: 'https://backend.dev.waiis.eco/api/backoffice',
  backofficeUrl: 'https://dashboard.dev.waiis.eco',
  googleMapsApiKey: 'AIzaSyDA62dvs0YXkbbI_rUKIhoIFbqNOjdTWSE',
  firebaseConfig: {
    apiKey: "AIzaSyB0ILl8f2Tv4pFV23_dJZ6OlbFvGr_6mgg",
    authDomain: "promising-silo-345210.firebaseapp.com",
    databaseURL: "https://promising-silo-345210-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "promising-silo-345210",
    storageBucket: "promising-silo-345210.firebasestorage.app",
    messagingSenderId: "958867453208",
    appId: "1:958867453208:web:117db59a29d1490b279a6d",
    measurementId: "G-RRMKD9WDHN",
  },
  // Firebase App Check (reCAPTCHA Enterprise). Es el ID de clave publico que
  // genera Google Cloud Console -> Security -> reCAPTCHA (tipo Website,
  // score-based, sin checkbox). No hay secret. Vacio = App Check desactivado.
  recaptchaEnterpriseSiteKey: '6LepJLstAAAAAPKMtfvAf3KmfLMbvotAUYeKNlH0',
  // Solo en local: imprime por consola un debug token que hay que registrar en
  // Firebase Console -> App Check -> la app -> Manage debug tokens.
  appCheckDebugToken: false,
  /* AUTH LOGIN */
  login: '/auth/login',
  verifiyCode: '/verify-code',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  corporations: '/corporations',
  corporationUser: '/corporation-users',
  footPrintUsers: '/footprint/users',
  corporation_offices: '/corporation-offices',
  shifts: '/shifts',
  giftProviders: '/gift-providers',
  coupons: '/gift-cards',
  codes: '/gift-codes',
  users: '/users',
  credits: '/credit-types',
  commisions: '/commissions',
  corporationSubsidies: '/corporation-subsidy',
  corporationSubsidyPricingConfigs: '/corporation-subsidy-pricing-configs',
  corporationOfficeSubsidyPricingConfigs:
    '/corporation-office-subsidy-pricing-configs',
  pmstDocuments: '/psmt/documents',
  corporationSubsidyConsumptions: '/corporation-subsidy-consumption',
  footPrintSegment: '/footprint/segment',

  promotionalCodes: '/coupons',
  couponZones: '/coupons/zones',
  walletMovements: '/wallet/movements',
  economicDashboard: '/economic-dashboard',
  corporationWallet: '/corporation-wallet',
  corporationPaymentMethods: '/corporation-payment-methods',
  stripePublishableKey:
    'pk_test_51LLPWrApveoBbcbcq6dQnWCPH3n8mqEYtFf88g3lpk2ZfO16u0MhfId4AI9n1y8rR5R5S661SOigB3MzjUYBYbFF00iGLKImh4',

  statistics: '/dashboard-statistics',
  corporationFleetKpis: '/corporation-fleet-kpis',
  corporationFleetConfig: '/corporation-fleet-config',
  corporationFunnel: '/corporations-users-funnel',
  funnel: '/funnel',
  carbonFootprintSaves: '/corporations-carbon-footprint-saves',
  carbonFootprintTotal: '/corporations-total-carbon-footprint',
  carbonFootprintByOffice: '/corporations-offices-footprint',
  monthlyEconomicCost: '/corporations-solo-shared-pooling-cost',
  monthlyCarbon: '/corporations-solo-shared-pooling-footprint',
  carbonFootprintByWorker: '/corporations-users-footprint',
  generalTravelStatistics: '/corporations-general-travel-statistics',
  corporationsUsageStatistics: '/corporations-usage-statistics',
  corporationsTravels: '/corporations-travels',
  corporationsTravelsFootprint: '/corporations-travels-footprint',
  corporationsTravelsRoutines: '/corporations-routine-users',
  corporationsTravelDays: '/corporations-travel-days',
  corporationsTravelHours: '/corporations-travel-hours',
  corporationsKpis: '/corporations-kpis',

  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  // Mock de flotas de taxi/VTC (docs/flotas-drivers/README.md#mocks): responde en el
  // navegador las rutas de flotas y de verificación de documentos mientras no hay backend.
  fleetMock: false,
  // Mock de «Condiciones de pago» del partner (src/app/mocks/partner-payments): responde
  // en el navegador el plazo y el calendario de abonos mientras no hay backend.
  partnerPaymentsMock: false,
  // Mock de los ajustes de anuncios por zona (src/app/mocks/zone-ad-settings): responde
  // en el navegador GET/PUT backoffice/zone-ad-settings mientras no hay backend.
  zoneAdSettingsMock: false,
  apiUrl: 'api',
  appThemeName: 'Metronic',
  appPurchaseUrl: 'https://1.envato.market/EA4JP',
  appHTMLIntegration:
    'https://preview.keenthemes.com/metronic8/demo1/documentation/base/helpers/flex-layouts.html',
  appPreviewUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1/',
  appPreviewAngularUrl:
    'https://preview.keenthemes.com/metronic8/angular/demo1',
  appPreviewDocsUrl: 'https://preview.keenthemes.com/metronic8/angular/docs',
  appPreviewChangelogUrl:
    'https://preview.keenthemes.com/metronic8/angular/docs/changelog',
  appDemos: {
    demo1: {
      title: 'Demo 1',
      description: 'Default Dashboard',
      published: true,
      thumbnail: './assets/media/demos/demo1.png',
    },

    demo2: {
      title: 'Demo 2',
      description: 'SaaS Application',
      published: true,
      thumbnail: './assets/media/demos/demo2.png',
    },

    demo3: {
      title: 'Demo 3',
      description: 'New Trend',
      published: true,
      thumbnail: './assets/media/demos/demo3.png',
    },

    demo4: {
      title: 'Demo 4',
      description: 'Intranet Application',
      published: true,
      thumbnail: './assets/media/demos/demo4.png',
    },

    demo5: {
      title: 'Demo 5',
      description: 'Support Forum',
      published: false,
      thumbnail: './assets/media/demos/demo5.png',
    },

    demo6: {
      title: 'Demo 6',
      description: 'Admin Backend',
      published: true,
      thumbnail: './assets/media/demos/demo6.png',
    },

    demo7: {
      title: 'Demo 7',
      description: 'CRM Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo7.png',
    },

    demo8: {
      title: 'Demo 8',
      description: 'Core Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo8.png',
    },

    demo9: {
      title: 'Demo 9',
      description: 'Fancy Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo9.png',
    },

    demo10: {
      title: 'Demo 10',
      description: 'Modern Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo10.png',
    },

    demo11: {
      title: 'Demo 11',
      description: 'Light Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo11.png',
    },

    demo12: {
      title: 'Demo 12',
      description: 'Reporting System',
      published: false,
      thumbnail: './assets/media/demos/demo12.png',
    },

    demo13: {
      title: 'Demo 13',
      description: 'Classic Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo13.png',
    },

    demo14: {
      title: 'Demo 14',
      description: 'Creative Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo14.png',
    },

    demo15: {
      title: 'Demo 15',
      description: 'Minimalistic Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo15.png',
    },

    demo16: {
      title: 'Demo 16',
      description: 'Modern Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo16.png',
    },

    demo17: {
      title: 'Demo 17',
      description: 'Backend System',
      published: false,
      thumbnail: './assets/media/demos/demo17.png',
    },

    demo18: {
      title: 'Demo 18',
      description: 'System Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo18.png',
    },

    demo19: {
      title: 'Demo 19',
      description: 'Light Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo19.png',
    },

    demo20: {
      title: 'Demo 20',
      description: 'Monochrome Dashboard',
      published: false,
      thumbnail: './assets/media/demos/demo20.png',
    },
  },
};
